import { render, staticRenderFns } from "./Medicare.vue?vue&type=template&id=7dc0b214&"
import script from "./Medicare.vue?vue&type=script&lang=js&"
export * from "./Medicare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports